// extracted by mini-css-extract-plugin
export default {"primary":"EditAccount_primary__Rib+E","remove":"EditAccount_remove__DXpze"};